import { IShader, ShaderBase } from './shader';
import { PBRMetallicRoughnessMaterial, Color3, Texture, Scene, Material } from '@babylonjs/core';

/**
 * Tutaj prosimy nie ruszać.
 */
export class ShaderNull extends ShaderBase implements IShader {

    public diffuse: string = '';
    public normal: string = '';
    public avatar: string = '200110_CREATIVE_empty.jpg';
    public text: string = 'push';

    public get key(): string { return 'ShaderNull'; }

    public getMaterial(scene: Scene, light: string = ''): PBRMetallicRoughnessMaterial {
        const material = new PBRMetallicRoughnessMaterial('material', scene);
        return material;
    }

    addLight(scene: Scene, material: Material, light: string): Material {
        return material;
    }
}
